import AdditionalListingsIssuesView from './additional-listings-issues-view';

const AdditionalListingsIssuesPage = {
    name: 'AdditionalListingsIssues',
    list: AdditionalListingsIssuesView
};

export default AdditionalListingsIssuesPage;
